import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FeatureService} from '../../features/clienti/feature.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CicloTrattamentoModalComponent} from './ciclo-trattamento-modal.component';
import {RiepilogoCiclo} from "../../models/RiepilogoCiclo";

@Component({
  selector: 'app-agenda-disponibilita-mantenimento',
  styles: [`
    .alert.alert-light {
      color: #535353 !important
    }
  `],
  template: `
    <div class="mt-2 alert alert-giallino" *ngIf="loaded && riepilogo?.id">
      <div class="mt-2"><strong>{{ riepilogo.categoria }}</strong></div>
      <strong class="mt-2">Disponibilità {{  riepilogo.tipologia }}</strong>:<br>
      <ul class="mb-0">
        <li *ngFor="let disponibilita of this.riepilogo.disponibilita">{{ disponibilita.giorno }}: {{ disponibilita.orario }}</li>
      </ul>
      <div><strong>Ultimo appuntamento eseguito</strong>: {{ riepilogo.ultimo_appuntamento_eseguito ? (riepilogo.ultimo_appuntamento_eseguito | date: 'dd/MM/yyyy') : '-' }}</div>
      <div><strong>Prossimo appuntamento programmato</strong>: {{ riepilogo.prossimo_appuntamento_programmato ? (riepilogo.prossimo_appuntamento_programmato | date: 'dd/MM/yyyy') : '-' }}</div>
      <div class="mt-2" *ngIf="noteAggiuntive"><strong>Note cliente</strong>: {{ noteAggiuntive }}</div>
    </div>
    <div class="mt-2 alert alert-giallino" *ngIf="loaded && !this.riepilogo">
      Non è ancora stato creato il mantenimento per il cliente selezionato. Per procedere clicca sul pulsante:
      <button (click)="handleCreate()" class="btn btn-primary mt-2">Crea {{ riepilogo.tipologia }}</button>
    </div>
    <div class="mt-2 alert alert-giallino" *ngIf="!loaded">
      Caricamento...
    </div>
  `
})

export class DisponibilitaMantenimentoComponent implements OnChanges {

  @Input() clienteId: number;
  @Input() tipologia: string;
  @Input() noteAggiuntive: string | null = null;

  loaded = false;
  riepilogo: RiepilogoCiclo | null;

  constructor(
    private service: FeatureService,
    private modalService: NgbModal
  ) {

  }

  getData(clienteId, tipologia) {
    this.loaded = false;
    this.service.riepilogoCiclo(clienteId, tipologia).subscribe((response: RiepilogoCiclo) => {
      this.loaded = true;
      if (response.id) {
        this.riepilogo = response;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

    const clienteId = changes.clienteId ? changes.clienteId.currentValue : this.clienteId;
    const tipologia = changes.tipologia ? changes.tipologia.currentValue : this.tipologia;

    // @ts-ignore
    this.getData(clienteId, tipologia);

  }

  handleCreate() {

    const instance = this.modalService.open(CicloTrattamentoModalComponent);
    instance.componentInstance.clienteId = this.clienteId;
    instance.componentInstance.categoria = 'mantenimento';
    instance.result.then(() => {
      this.getData(this.clienteId, 'mantenimento');
    });

  }

}
